import uuidv4 from 'uuid/v4';

export const NEW_PROJECT = 'Projects/NEW_PROJECT';
export const NEW_PROJECT_DEVELOPER = 'Projects/NEW_PROJECT_DEVELOPER';
export const UPDATE_PROJECT_TITLE = 'Projects/UPDATE_PROJECT_TITLE';
export const REMOVE_PROJECT_DEVELOPER = 'Projects/REMOVE_PROJECT_DEVELOPER';
export const REORDER_PROJECT_WEEK = 'Projects/REORDER_PROJECT_WEEK';
export const REORDER_PROJECTS = 'Projects/REORDER_PROJECTS';
export const MOVE_DEVELOPER_PROJECT = 'Projects/MOVE_DEVELOPER_PROJECT';
export const UPDATE_WEEK_NOTE = 'Projects/UPDATE_WEEK_NOTE';
export const DROP_FIRST_COLUMN = 'Projects/DROP_FIRST_COLUMN';

export const dropFirstColumn = () => ({
  type: DROP_FIRST_COLUMN,
});

export const newProject = () => {
  const projectId = uuidv4();
  return {
    type: NEW_PROJECT,
    project: {
      id: projectId,
      title: 'New Project',
      weeks: [
        { projectId, id: uuidv4(), developers: [] },
        { projectId, id: uuidv4(), developers: [] },
        { projectId, id: uuidv4(), developers: [] },
        { projectId, id: uuidv4(), developers: [] },
        { projectId, id: uuidv4(), developers: [] },
        { projectId, id: uuidv4(), developers: [] },
        { projectId, id: uuidv4(), developers: [] },
        { projectId, id: uuidv4(), developers: [] },
        { projectId, id: uuidv4(), developers: [] },
        { projectId, id: uuidv4(), developers: [] },
        { projectId, id: uuidv4(), developers: [] },
        { projectId, id: uuidv4(), developers: [] },
      ],
    },
  };
};

export const updateProjectTitle = (id, title) => {
  return {
    type: UPDATE_PROJECT_TITLE,
    id,
    title,
  };
};

export const newProjectDeveloper = (weekId, developer, index) => {
  return {
    type: NEW_PROJECT_DEVELOPER,
    weekId,
    developer: {
      ...developer,
      id: uuidv4(),
    },
    index,
  };
};

export const removeProjectDeveloper = developerId => {
  return {
    type: REMOVE_PROJECT_DEVELOPER,
    developerId,
  };
};

export const reorderProjectWeek = (weekId, developers) => {
  return {
    type: REORDER_PROJECT_WEEK,
    weekId,
    developers,
  };
};

export const reorderProjects = projects => {
  return {
    type: REORDER_PROJECTS,
    projects,
  };
};

export const updateWeekNote = (weekId, note) => {
  return {
    type: UPDATE_WEEK_NOTE,
    weekId,
    note,
  };
};

export const moveDeveloper = (
  sourceWeekId,
  destinationWeekId,
  developer,
  index,
) => {
  return {
    type: MOVE_DEVELOPER_PROJECT,
    sourceWeekId,
    destinationWeekId,
    developer,
    index,
  };
};



// WEBPACK FOOTER //
// ./src/actions/projects.js